import { Component, computed, inject, input, Signal } from '@angular/core';
import { ReleaseObjectGroupViewModel, ReleaseSelectedObject } from '../../models/autogenerated-piping';
import { ReleaseLifecycleService } from '../../services/release-lifecycle.service';

/**
 * Header badge showing the release life cycle (release as is / revise / retire) of a pipe class or valve.
 * Renders nothing outside a release or once the release is published.
 */
@Component({
  selector: 'app-release-lifecycle-badge',
  templateUrl: './release-lifecycle-badge.component.html',
  styleUrls: ['./release-lifecycle-badge.component.scss'],
  standalone: false
})
export class ReleaseLifecycleBadgeComponent {
  private readonly lifecycleService: ReleaseLifecycleService = inject(ReleaseLifecycleService);

  /** The release object group returned with the pipe class or valve. */
  objectGroup = input<ReleaseObjectGroupViewModel | undefined | null>(undefined);

  readonly isVisible: Signal<boolean> = computed(() => this.lifecycleService.isLifecycleApplicable(this.objectGroup()));
  readonly label: Signal<string> = computed(() => this.lifecycleService.getLabel(this.objectGroup()?.action));
  readonly cssClass: Signal<string> = computed(() => {
    switch (this.objectGroup()?.action) {
      case ReleaseSelectedObject._1: return 'lifecycle-badge--revise';
      case ReleaseSelectedObject._2: return 'lifecycle-badge--retire';
      default: return 'lifecycle-badge--as-is';
    }
  });
  readonly tooltip: Signal<string> = computed(() => {
    switch (this.objectGroup()?.action) {
      case ReleaseSelectedObject._1: return 'This item will be published with changes in its release.';
      case ReleaseSelectedObject._2: return 'This item will be retired by its release and cannot be edited.';
      default: return 'This item will be published unchanged. Saving changes moves it to "revise".';
    }
  });
}
